import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from "@angular/material/dialog";
import {HazardsFilters} from "../../hazards/hazards-filter/hazards-filter.interface";

@Component({
  selector: 'app-safety-observations-view-hazards-filter',
  templateUrl: './safety-observations-view-hazards-filter.component.html',
  styleUrls: ['./safety-observations-view-hazards-filter.component.scss']
})
export class SafetyObservationsViewHazardsFilterComponent implements OnInit {
  filters: HazardsFilters = {
    status: ''
  } as HazardsFilters;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private dialogRef: MatDialogRef<SafetyObservationsViewHazardsFilterComponent>
  ) { }

  ngOnInit(): void {
    // Set default values if not provided.
    this.filters.status = this.data['status'] || '';
  }

  /**
   * Clears the filters and closes the form.
   *
   * @return {void}
   */
  onClearAndClose(): void {
    // Clear the filters.
    this.filters.status = '';

    this.onSaveAndClose();
  }

  /**
   * Saves the filters and closes the dialog.
   *
   * @return {void}
   */
  onSaveAndClose(): void {
    this.dialogRef.close(this.filters);
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
